import React, { useState, useEffect } from "react";
import {
    Card,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Collapse,
    Divider,
    useMediaQuery
} from "@mui/material";
const Dummy = () => {
    const [isOpen, setIsOpen] = useState(false);
    const isTablet = useMediaQuery("(max-width: 1024px)");  // Detects iPad-sized screens

    return (
        <Box sx={{ width: "100%", minHeight: 0.5 , p: 0 }}></Box>
    )
};

export default Dummy;
